var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isResponsible
        ? _c(
            "popper",
            {
              ref: "popper",
              attrs: {
                trigger: "clickToToggle",
                "append-to-body": true,
                "visible-arrow": false,
                "root-class": "profile-user-popper",
                options: _vm.popperOptions,
              },
            },
            [
              _c("div", { staticClass: "profile-menu profile-user-nav" }, [
                _c("article", [
                  _c("h4", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(_vm.$t("pages.users.my_profile"))),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col text-center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "user-type-icon user-type-icon-left",
                          class: {
                            "user-type-no-active": _vm.isCurrentRoleResponsible,
                          },
                          on: { click: _vm.setEmployeeRole },
                        },
                        [
                          _c("img", {
                            staticClass: "user-icon",
                            attrs: {
                              src: require("@/assets/IC_Empleado.png"),
                              alt: "image",
                            },
                          }),
                        ]
                      ),
                      _c("p", { staticClass: "user-type" }, [
                        _vm._v(_vm._s(_vm.$t("pages.users.employee"))),
                      ]),
                    ]),
                    _c("div", { staticClass: "col text-center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "user-type-icon user-type-icon-right",
                          class: {
                            "user-type-no-active": _vm.isCurrentRoleEmployee,
                          },
                          on: { click: _vm.setResponsibleRole },
                        },
                        [
                          _c("img", {
                            staticClass: "user-icon",
                            attrs: {
                              src: require("@/assets/IC_Jefe.png"),
                              alt: "image",
                            },
                          }),
                        ]
                      ),
                      _c("p", { staticClass: "user-type" }, [
                        _vm._v(_vm._s(_vm.$t("pages.users.boss"))),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "row py-3" }, [
                    _c("div", { staticClass: "col text-right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "profile-link",
                          attrs: { href: "#" },
                          on: { click: _vm.toProfilePage },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("pages.users.see_my_data")) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "fas fa-chevron-right",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { attrs: { slot: "reference" }, slot: "reference" }, [
                _c(
                  "button",
                  {
                    staticClass: "name-user name-user--button",
                    attrs: { type: "button" },
                  },
                  [
                    _c("span", { staticClass: "name-user__label" }, [
                      _c("span", { staticClass: "name-user__name" }, [
                        _vm._v(_vm._s(_vm.userName)),
                      ]),
                      _c("span", { staticClass: "name-user__sep" }, [
                        _vm._v("·"),
                      ]),
                      _c(
                        "span",
                        { staticClass: "name-user__role" },
                        [
                          _vm.isCurrentRoleEmployee
                            ? [_vm._v(_vm._s(_vm.$t("pages.users.employee")))]
                            : [_vm._v(_vm._s(_vm.$t("pages.users.boss")))],
                        ],
                        2
                      ),
                    ]),
                    _c("i", {
                      staticClass: "fas fa-chevron-down name-user__chevron",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
              ]),
            ]
          )
        : _c(
            "div",
            { staticClass: "name-user name-user--link" },
            [
              _c("router-link", { attrs: { to: { name: "profile" } } }, [
                _c("span", [_vm._v(_vm._s(_vm.userName))]),
              ]),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }